export default {
  white: "#ffffff",
  grey: '#cccccc',
  blue: '#007bff',
};


// WEBPACK FOOTER //
// ./src/styles/colors.js